import { useEffect, useState } from "react";
import { Select } from "antd";
import axios from "axios";
import { API_BASE_URL } from "../../api";
import { getSuperGroupName } from "../../utils/getSuperGroupName";


const SuperGroupSelector = ({ value, onChange, placeholder = "Select Super Group", ...props }) => {
  const [superGroups, setSuperGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSuperGroups = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_BASE_URL}/tests/super-groups`);
        setSuperGroups(response.data);
      } catch (_error) {
        console.error("Error fetching super groups:", _error);
        setSuperGroups([]);
      } finally {
        setLoading(false);
      }
    };
    fetchSuperGroups();
  }, []);

  return (
    <Select
      showSearch
      defaultValue={value}
      value={value}
      onChange={(val) => {
        if (onChange) onChange(val);
      }}
      placeholder={placeholder}
      loading={loading}
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      {...props}
    >
      { superGroups.map((superGroup) => (
        <Select.Option key={superGroup} value={superGroup}>
          {getSuperGroupName(superGroup)}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SuperGroupSelector;
